import { Box, Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  colorLandingHeroBg,
  colorLandingHeroText,
  colorLandingSurface,
  fontLandingDisplay,
} from "src/design/tokens";
import { LandingButton } from "src/components/LandingPage/components/LandingButton";
import { useSectionNavigation } from "./useSectionNavigation";

/**
 * Opening statement on the slate hero: the two-channel promise plus the demo
 * and features CTAs. Deliberately copy-only — the product shots live in the
 * ecosystem section right below.
 */
export const HeroSection = () => {
  const { t } = useTranslation();
  const scrollToSection = useSectionNavigation();

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: colorLandingHeroBg,
        py: { xs: 7, md: 9 },
        textAlign: "center",
      }}
    >
      <Container maxWidth="lg">
        <Grid container justifyContent="center">
          <Grid item xs={12} md={10}>
            <Typography
              component="h1"
              sx={{
                fontFamily: fontLandingDisplay,
                fontWeight: 400,
                fontSize: { xs: 34, sm: 44, md: 58 },
                lineHeight: 1.08,
                letterSpacing: "-0.005em",
                color: colorLandingSurface,
              }}
            >
              {t("landingPage.hero.title")}
            </Typography>

            <Typography
              sx={{
                mt: 2,
                mx: "auto",
                maxWidth: "56ch",
                fontSize: { xs: 16, md: 18 },
                lineHeight: 1.6,
                color: colorLandingHeroText,
              }}
            >
              {t("landingPage.hero.subtitle")}
            </Typography>

            <Box
              sx={{
                mt: 3.75,
                display: "flex",
                gap: 1.75,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <LandingButton
                label={t("landingPage.hero.cta")}
                onClick={() => scrollToSection("demo")}
              />
              <LandingButton
                label={t("landingPage.hero.secondaryCta")}
                variant="ghostOnDark"
                onClick={() => scrollToSection("fonctionnalites")}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
